// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__TtrxK8TQcKxrTyVy5y {\r\n  width: 345px;\r\n  height: 45px;\r\n  border-radius: 4px;\r\n  margin-right: 40px;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/components/content/ContentActions/FilterCategory/FilterCategory.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["#filter-category {\r\n  width: 345px;\r\n  height: 45px;\r\n  border-radius: 4px;\r\n  margin-right: 40px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter-category": "__TtrxK8TQcKxrTyVy5y"
};
export default ___CSS_LOADER_EXPORT___;
